import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-delegate-home-mobile-explanation',
  templateUrl: './delegate-home-mobile-explanation.component.html',
  styleUrls: ['./delegate-home-mobile-explanation.component.scss']
})
export class DelegateHomeMobileExplanationComponent implements OnInit {
  public isDefaultTheme: boolean;
  public activeTheme: any;
  public text: string;
  public isLifeFileTheme: boolean;

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    switch (this.activeTheme.name) {
      case 'lifeFile':
        this.text = 'Life File';
        break;
      case 'pemTheme':
        this.text = 'PEM';
        break;
      case 'palmersTheme':
        this.text = 'Palmers Solicitors';
        break;
    }
  }

}
